import personalData from '@/store/Module/personalData'
import modal from '@/store/Module/modal'
import name from '@/store/Module/name'

const module = {
  personalData: personalData,
  modal: modal,
  name: name
}

export default module



// WEBPACK FOOTER //
// ./src/store/Module/index.js